import React from "react";
import Status from 'components/presentation/Status';
import { dateFormat } from "helpers/utils"
import ScoresLiveCard from "components/common/ScoresLiveCard";
import { Link } from "react-router-dom";
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import Label from "components/general/Label";
import Competitor from "components/presentation/Competitor";
import { isFinishedStatus } from "helpers/status";
import { useEventUnit } from "components/common/EventUnit";
import useViewport from "components/general/useViewPort";
import { getEventRSC } from "helpers/rsc";
import SvgMirs from "components/presentation/SvgMirs";


export function Footer({ data }) {
    return (
        <div className='scores-today-status'>
            <Status typeToPrint={'result'} scheduleStatus={data?.status?.code} resultStatus={data?.result?.status?.code} />
        </div>
    )
}

export function Header({ data }) {
    let number = data?.result?.extendedInfos?.find(i => i?.ei_code === 'UNIT_NUMBER') ? data?.result?.extendedInfos?.find(i => i?.ei_code === 'UNIT_NUMBER')?.ei_value : ''
    let runningMatch = data?.result?.extendedInfos?.find(i => i?.extensions?.find(f => f?.eie_value === 'RUNNING'))
    let category = runningMatch?.extensions?.find(i => i?.eie_code === 'WEIGHT_CATEGORY')?.eie_value
    let eu = useEventUnit()
    let dataHeader = eu(category)
    return (
        <>
            <div className='scores-today-header'>
                <div className='scores-today-piste'>
                    <div className='flex-grow-1'>
                        {data?.eventUnit?.description}
                        <p>{dataHeader !== '-' ? dataHeader : ''}</p>
                    </div>
                    <div className='text-end'>
                        {data?.eventUnit?.code.includes('TEAM')
                            ? <><Label data="HeaderMatch" /> {number}</>
                            : <><Label data="LabelContest" /> {number}</>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export function CardsLayout({ results }) {
    const { breakPoint } = useViewport();

    const isMobile = breakPoint === "sm" || breakPoint === "xs"

    const mat1 = [];
    const mat2 = [];
    results?.forEach(item => {
        if (item?.location?.code === 'JU1')
            mat1.push(item)
        else if (item?.location?.code === 'JU2')
            mat2.push(item)
    })

    const session1 = results[0]?.session?.startDate
    const mat1session1 = [];
    const mat1session2 = [];
    const mat2session1 = [];
    const mat2session2 = [];

    mat1?.forEach(item => {
        if (item?.session?.startDate === session1)
            mat1session1.push(item)
        else if (item?.session?.startDate !== session1)
            mat1session2.push(item)
    })

    mat2?.forEach(item => {
        if (item?.session?.startDate === session1)
            mat2session1.push(item)
        else if (item?.session?.startDate !== session1)
            mat2session2.push(item)
    })

    const mat1Finished = mat1?.filter(item => isFinishedStatus(item?.result?.status?.code))
    mat1Finished.sort(function (a, b) { return a - b });
    let last1Finished = mat1Finished.slice(-1)

    const mat2Finished = mat2?.filter(item => isFinishedStatus(item?.result?.status?.code))
    mat2Finished.sort(function (a, b) { return a - b });
    let last2Finished = mat2Finished.slice(-1)

    return (
        <>
            <div className="container scores-today-match">
                <div className="scores-today-header">
                    <div className={isMobile ? '' : 'row'}>
                        <div className={isMobile ? '' : 'col-6'}>
                            {mat1session1.length !== 0 &&
                                <>
                                    <div className="card scores-today-wre-location ">
                                        <div className="card-body d-flex justify-content-between">
                                            <div className="fw-bold">
                                                {mat1session1[0]?.location?.shortDescription}
                                            </div>
                                            <div className='text-end'>
                                                <Label data="HeaderStartAt" /> {dateFormat(mat1session1[0]?.session?.startDate, undefined, 'HH:mm')}
                                            </div>
                                        </div>
                                    </div>
                                    {results && mat1session1?.map(item => {
                                        if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last1Finished[0]?.eventUnit?.code)
                                            return ''
                                        else
                                            return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                    })}
                                </>
                            }
                            {mat1session2.length !== 0 &&
                                <>
                                    <div className="card scores-today-wre-location ">
                                        <div className="card-body d-flex justify-content-between">
                                            <div className="fw-bold">
                                                {mat1session2[0]?.location?.shortDescription}
                                            </div>
                                            <div className='text-end'>
                                                <Label data="HeaderStartAt" /> {dateFormat(mat1session2[0]?.session?.startDate, undefined, 'HH:mm')}
                                            </div>
                                        </div>
                                    </div>
                                    {results && mat1session2?.map(item => {
                                        if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last1Finished[0]?.eventUnit?.code)
                                            return ''
                                        else
                                            return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                    })}
                                </>
                            }
                        </div>
                        <div className={isMobile ? '' : 'col-6'}>
                            {mat2session1.length !== 0 &&
                                <>
                                    <div className="card scores-today-wre-location ">
                                        <div className="card-body d-flex justify-content-between">
                                            <div className="fw-bold">
                                                {mat2session1[0]?.location?.shortDescription}
                                            </div>
                                            <div className='text-end'>
                                                <Label data="HeaderStartAt" /> {dateFormat(mat2session1[0]?.session?.startDate, undefined, 'HH:mm')}
                                            </div>
                                        </div>
                                    </div>
                                    {results && mat2session1?.map(item => {
                                        if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last2Finished[0]?.eventUnit?.code)
                                            return ''
                                        else
                                            return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                    })}
                                </>
                            }
                            {mat2session2.length !== 0 &&
                                <>
                                    <div className="card scores-today-wre-location ">
                                        <div className="card-body d-flex justify-content-between">
                                            <div className="fw-bold">
                                                {mat2session2[0]?.location?.shortDescription}
                                            </div>
                                            <div className='text-end'>
                                                <Label data="HeaderStartAt" /> {dateFormat(mat2session2[0]?.session?.startDate, undefined, 'HH:mm')}
                                            </div>
                                        </div>
                                    </div>
                                    {results && mat2session2?.map(item => {
                                        if (isFinishedStatus(item?.result?.status?.code) && item?.eventUnit?.code !== last2Finished[0]?.eventUnit?.code)
                                            return ''
                                        else
                                            return <ScoresLiveCard data={item} key={item?.eventUnit?.code} />
                                    })}
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export function BodyComponent({ data, competitorComponent, competitorNoDataComponent }) {
    const getURL = useGetURL()
    const CompetitorComponent = competitorComponent || <></>
    const CompetitorNoDataComponent = competitorNoDataComponent || <></>
    let paramsURL = { ...useUrlFriendlyToParameters() }
    paramsURL["mirs_rsc"] = data?.eventUnit?.code
    if (!paramsURL["mirs_event"]) {
        paramsURL["mirs_event"] = getEventRSC(data?.eventUnit?.code)
    }
    const url = getURL({ ...paramsURL }, 'results')
    const sortedItems = data?.result?.items.sort((a, b) => a.sortOrder - b.sortOrder);
    let currentAth = data?.result?.extendedInfos?.find(i => i?.extensions?.find(f => f?.eie_value === 'RUNNING'))
    let currentHomeAth = currentAth?.extensions?.find(i => i?.eie_code === 'HOME')?.eie_value
    let currentAwayAth = currentAth?.extensions?.find(i => i?.eie_code === 'AWAY')?.eie_value

    const out = sortedItems?.map(item => {
        let color = item?.sortOrder === 1 ? 'white' : 'blue'
        let homeAth = item?.teamAthletes?.find(i => i?.athlete?.code === currentHomeAth)
        let homeCurrentScore = homeAth?.extResults?.find(f => f?.er_code === 'CONTEST')?.er_value
        let awayAth = item?.teamAthletes?.find(i => i?.athlete?.code === currentAwayAth)
        let awayCurrentScore = awayAth?.extResults?.find(f => f?.er_code === 'CONTEST')?.er_value
        return (


            <Link key={item?.sortOrder} to={url} >
                <div className='score-line d-flex flex-row'>
                    {item?.participant && <div className={"scores-today-wre-box m-1 bg-" + color} />}
                    {item?.participant ? <CompetitorComponent extendedInfos={data?.result?.extendedInfos} {...item} /> : <CompetitorNoDataComponent {...item} />}
                    {/** Results in match */}
                    {item?.itemType === 'T' && homeCurrentScore &&
                        <div className='d-flex text-start'>
                            <Competitor {...homeAth?.athlete} hideNoc={true} hidePicture={true} noLink={true} />&nbsp;
                            {homeCurrentScore}
                        </div>
                    }
                    {item?.itemType === 'T' && awayCurrentScore &&
                        <div className='d-flex'>
                            <Competitor {...awayAth?.athlete} hideNoc={true} hidePicture={true} noLink={true} />&nbsp;
                            {awayCurrentScore}
                        </div>
                    }

                    <div /*style={{marginLeft:'50px'}}*/>
                        <Score resultJson={item?.resultDataText} />
                    </div>

                </div>
            </Link>
        )
    })

    return (
        <>{out}</>
    )

}

export function Score(props) {
    const { resultJson } = props;
    let resultObj = resultJson ? JSON.parse(resultJson) : {};
    const winner = resultObj?.wlt === 'W' &&
        <div className='score-winner'><SvgMirs className='mirsIcon score-winner' role="img" title='HeaderWinner' code='circle-check' /></div>
    const result = resultObj?.result;

    const dataH = resultObj?.extra?.totH;
    const dataX = resultObj?.extra?.totX;
    const dataS3 = resultObj?.extra?.totS3;
    const dataS = parseInt(resultObj?.extra?.totS);

    //const technique = props?.screen === undefined && resultObj?.wlt === 'W' && resultObj?.extra?.techCode ? resultObj?.extra?.techCode : ''
    let dataPenalties
    if (dataS > 0) {
        for (let i = 0; i < dataS; i++) {
            dataPenalties = <>{dataPenalties} <SvgMirs className="mirsIcon" role="img" title='LabelYCDesc' code='yellow-card' /> </>
        }
    } else if (dataH === '1' || dataX === '1' || dataS3 === '1') {
        dataPenalties = <> <SvgMirs className="mirsIcon" role="img" title='LabelRCDesc' code='red-card' /></>
    } else {
        dataPenalties = <> <SvgMirs className='mirsIcon' title='HeaderWCDesc' code='white-card' /></>
    }

    return (
        <div className='score-result-container'>
            <div className="d-flex flex-nowrap align-items-center justify-content-end">
                <div className='score-result '>
                    {winner}
                </div>
                <div className={`score-result ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'}`}>
                    {result}
                </div>
                <div className='score-cards-jud '>
                    {dataPenalties}
                </div>
                {/*<div className='score-result '>
                    {technique}
                </div>*/}
            </div>
        </div>
    )
}
